import styled, { css } from "styled-components"
import { rgba, darken } from "polished"
import { FeedbackType } from "../"

export const CheckboxStyle = styled.div<{ feedbackType?: FeedbackType }>`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  cursor: default;
  a {
    color: ${(p) => p.theme.colors.purple};
    &:hover {
      color: ${(p) => darken(0.1, p.theme.colors.purple)};
    }
  }
  input {
    opacity: 0;
  }

  input {
    height: 1.25rem;
    width: 1.25rem;
  }

  span {
    background: ${(p) => p.theme.colors.card.default};
    border: 1px solid ${(p) => p.theme.colors.softGrey};
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 1.25rem;
    width: 1.25rem;
    pointer-events: none;
    transition: background 0.2s ease-in-out;
  }

  label {
    margin: 0 0.75rem;
    display: block;
    font-size: 0.875rem;
  }

  input:checked ~ span {
    border-color: ${(p) => p.theme.colors.purple};
  }

  input {
    opacity: 0;
  }

  span {
    ${(p) =>
      p.feedbackType === "error" &&
      css`
        border-color: ${p.theme.colors.red.border};
      `};

    svg {
      width: 0.75rem;
      height: 0.75rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.2s ease-in-out;
      opacity: 0;
      fill: white;
    }
  }

  input:checked ~ span {
    background: ${(p) => rgba(p.theme.colors.purple, 1)};
    svg {
      opacity: 1;
    }
  }
`
